import { pending } from 'patronum';
import { fxGetData } from './model';

/** Передавать все эффекты раздела */
export const $isLoading = pending({
  effects: [fxGetData],
});
